import { render, staticRenderFns } from "./PresentationEditor.vue?vue&type=template&id=209fdb9a&scoped=true"
import script from "./PresentationEditor.vue?vue&type=script&lang=js"
export * from "./PresentationEditor.vue?vue&type=script&lang=js"
import style0 from "./PresentationEditor.vue?vue&type=style&index=0&id=209fdb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209fdb9a",
  null
  
)

export default component.exports